
import './formTextArea.css';
import { useState } from 'react';

function FormTextArea({ label, itemInput, setItemInput, auth, inactive, areaH }) {

    const changeHandler = (e) => {
        setItemInput(e.target.value);
        setAreaHeight(e.target.scrollHeight);
    }

    const [areaHeight, setAreaHeight] = useState(areaH || 42);

    return (
        <div className={['formInput', inactive ? 'inactive' : ''].join(' ')} style={auth ? { width: '100%' } : { width: '160px' }}>
            <textarea onChange={changeHandler} value={itemInput} className={itemInput.trim() != "" ? 'has-value' : ''} style={{ height: `${areaHeight}px` }}></textarea>
            <label>{label}</label>
        </div>
    )
}
export default FormTextArea